// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2by8O","colBig":"styles_colBig__3sIpP","colSmall":"styles_colSmall__tclrk"};